import { configureStore } from "@reduxjs/toolkit";
import gamesMetaReducer from "./slice/gamesMeta";
import resultReducer from "./slice/result";
import spinnerReducer from "./slice/spinner";
import gamePlayReducer from "./slice/gamePlay";

const reducer = {
  gamesMeta: gamesMetaReducer,
  result: resultReducer,
  spinner: spinnerReducer,
  gamePlay: gamePlayReducer,
};

const store = configureStore({
  reducer,
  devTools: true,
});

export default store;
